<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    @if (ineligibleAsins().length > 0) {
      <IAlert type="warning" [title]="t('sd-page.ineligible_asins', { count: ineligibleAsins().length })">
        <div class="mt-2">
          {{ ineligibleAsins().slice(0, 20).join(", ") }}{{ ineligibleAsins().length > 20 ? ", …" : "" }}
        </div>
      </IAlert>
    }

    @if (missingAsinsInSb()?.length) {
      <IAlert [title]="t('tacos-strategy.missing_asins_in_sb')" type="warning">
        {{ t("tacos-strategy.missing_asins_in_sb_description") }} <br />
        @for (asin of missingAsinsInSb(); track asin) {
          {{ asin + ($last ? "" : ", ") }}
        }
      </IAlert>
    }

    <div class="flex justify-end gap-2">
      @if (deleteProductSelection().length > 0) {
        <button
          iButton
          variant="destructive"
          [loading]="deleteProductLoading()"
          [disabled]="isReadOnly()"
          (click)="removeAsinsFromTacos(deleteProductSelection())"
        >
          <IIcon name="trash" />
          {{ t("common.delete") }}
        </button>
      }
      <button iButton variant="secondary" [disabled]="isReadOnly()" (click)="openAddAsinsModal()">
        <IIcon name="add" />
        {{ t("common.add") }}
      </button>
    </div>
    <div class="flex max-h-[30rem] min-h-0 overflow-y-auto">
      <app-asin-selection
        class="max-h-full w-full"
        ineligibilityTag="SP"
        [customList]="asinList()"
        [(selectedAsins)]="deleteProductSelection"
        [csvExport]="true"
        [readonly]="isReadOnly()"
      />
    </div>
  </div>

  <ng-template #addAsinsModal>
    <div class="relative flex h-full flex-col gap-4">
      @if (addProductLoading()) {
        <div class="absolute inset-0 flex items-center justify-center">
          <ISpinner [display]="true" />
        </div>
      }

      <app-asin-selection
        class="min-h-0 flex-1"
        [ngClass]="{ 'pointer-events-none opacity-50': addProductLoading() }"
        [csvExport]="false"
        [customList]="productAvailableToAdd()"
        [(selectedAsins)]="addProductSelection"
        ineligibilityTag="SP"
      />

      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" (click)="addAsinsModalRef?.close()">{{ t("common.cancel") }}</button>
        <button
          iButton
          [loading]="addProductLoading()"
          [disabled]="addProductSelection().length === 0"
          (click)="addAsinsToTacos(addProductSelection())"
        >
          {{ t("sp-substrategy.add_products") }}
        </button>
      </div>
    </div>
  </ng-template>
</ng-container>
